import { selectUserId } from 'containers/Login/loginSlice'
import { useHistory, useLocation } from 'react-router-dom'
import { LOCATION_STATES } from 'utils/constants'
import { useSelector } from 'react-redux'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'
import { useState } from 'react'
import { v7 } from 'uuid'

const usePaymentProcessing = (selectedPayment, getInvoices, amount, paymentMethods) => {
  const [isLoading, setLoading] = useState(false)
  const userId = useSelector(selectUserId)
  const { pathname } = useLocation()

  const { push } = useHistory()
  const getPayment = () => {
    const payment = {
      amount,
      methodId: selectedPayment.methodId,
      date: 'now'
    }
    if (selectedPayment.optionId) {
      payment.optionId = selectedPayment.optionId
    }
    return payment
  }

  const generateBody = async (localPaymentId, code) => {
    const payment = getPayment()
    const invoices = await getInvoices(payment)
    payment.init = true
    payment.localPaymentId = localPaymentId
    if (code) {
      payment.code = code
    }
  
    return {
      cartId: null,
      action: 'payment',
      userId,
      invoices,
      payments: [payment]
    }
  }


  const initOnlinePayment = async () => {
    const body = generateBody(v7(), '')
    if (!body) return
    const response = await POST(urls.paymentSettlement, { body })
    if (response?.url) {
      window.open(response.url, '_self')
      setTimeout(() => {
        setLoading(false)
      }, 500)

    } else {
      console.error('Coś poszło nie tak...')
      setLoading(false)
    }
  }

  const purchase = async () => {
    if (isLoading) return
    setLoading(true)
    const payment = getPayment()
    const blikId = paymentMethods?.find(p => p.key === 'blik')?.id
    switch (payment.methodId) {
      case blikId:
        push(pathname, LOCATION_STATES.popup({ type: 'blik', payment }))
        break

      default:
        initOnlinePayment()
    }
  }

  return {
    isProcessing: isLoading,
    purchase,
    generateBody
  }
}

export default usePaymentProcessing